import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = { class: "empty-state" }
const _hoisted_3 = { class: "empty-state-icon" }
const _hoisted_4 = { class: "text-muted text-body-2" }
const _hoisted_5 = { class: "px-4 pb-4" }

import AppButtonFlat from "@/shared/components/ui/AppButtonFlat.vue";
import { useModalStore } from "@/shared/stores/modal";
import AssignProfessionalModal from "@/modules/vendor/components/appointments/AssignProfessionalModal.vue";
import { ref } from "vue";

import { fetchServiceProviders } from "@/modules/vendor/services/vendors.api";


export default /*@__PURE__*/_defineComponent({
  __name: 'NoProfessionalAssigned',
  props: {
    appointment: {},
    message: { default: "No professional assigned" },
    buttonText: { default: "Assign Now" }
  },
  emits: ["assigned"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const modal = useModalStore();
const isLoadingProviders = ref(false);

async function handleAssignProfessional() {
  const vendorId = props.appointment.vendor_id;
  isLoadingProviders.value = true;

  try {
    const providersResponse = vendorId ? await fetchServiceProviders(vendorId) : [];
    console.log("providersResponse", providersResponse);
    const providers = Array.isArray(providersResponse)
      ? providersResponse
      : Array.isArray((providersResponse as any)?.data)
      ? (providersResponse as any).data
      : [];

    modal.open(
      AssignProfessionalModal,
      {
        appointment: props.appointment,
        providers,
        onAssigned: (appointment: Record<string, any>, provider: any | null) => {
          emit("assigned");
        },
      },
      {
        fullscreen: true,
        showHeader: false,
        title: "Assign Professional",
        scrollable: true,
      }
    );
  } finally {
    isLoadingProviders.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_icon, {
          size: "22",
          color: "primary"
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createTextVNode("mdi-account-plus-outline", -1)
          ]))]),
          _: 1
        })
      ]),
      _createElementVNode("p", _hoisted_4, _toDisplayString(__props.message), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(AppButtonFlat, {
        block: "",
        "prepend-icon": "mdi-account-plus",
        loading: isLoadingProviders.value,
        disabled: isLoadingProviders.value,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (handleAssignProfessional()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(__props.buttonText), 1)
        ]),
        _: 1
      }, 8, ["loading", "disabled"])
    ])
  ]))
}
}

})